export default __webpack_public_path__ + "static/alex-55f1b5ec7723a5298e9178ca0cf73ad6.webp";